import { defaultDatePickerStrings } from "@fluentui/react";

export const systemInfoPickerStrings = {
  ...defaultDatePickerStrings,
  months: [
    "Januari",
    "Februari",
    "Mars",
    "April",
    "Maj",
    "Juni",
    "Juli",
    "Augusti",
    "September",
    "Oktober",
    "November",
    "December",
  ],
  shortMonths: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Maj",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dec",
  ],
  days: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"],
  shortDays: ["S", "M", "T", "O", "T", "F", "L"],
  goToToday: "Gå till idag",
  prevMonthAriaLabel: "Föregående månad",
  nextMonthAriaLabel: "Nästa månad",
  prevYearAriaLabel: "Föregående år",
  nextYearAriaLabel: "Nästa år",
  closeButtonAriaLabel: "Stäng datumväljare",
};
